// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"857dcb59","14":"6fd066a7","38":"7b767aea","134":"2ca0b63d","449":"e264514f","617":"862057fd","659":"c7c2df1c","758":"80b170d7","778":"4b7c3d9f","912":"b3f21550"}[chunkId] + ".chunk.js";
};